import { appointmentStatusLabel } from "@/constants/appointments/appointments-constants";
import type { Appointment } from "@/types/appointments/api-types/appointment-types";

import { isoDate } from "@/lib/utils";

import { DataCard, ServiceLines } from "./data-card";
import { useIntl } from "react-intl";

export function DiaryCard({
  dateFrom,
  dateTo,
  appointments,
}: {
  dateFrom: string;
  dateTo?: string | null;
  appointments: Appointment[];
}) {
  const intl = useIntl();
  const days = intl.formatDateTimeRange(isoDate(dateFrom), isoDate(dateTo ?? dateFrom), { format: "day" });
  const count = appointments.length === 1 ? "1 booking" : `${appointments.length} bookings`;

  return (
    <DataCard summary={`${days} · ${count}`}>
      {appointments.length === 0 && <p className="text-muted-foreground">No bookings.</p>}
      {appointments.map((appointment) => (
        <div key={appointment.id} className="flex flex-col gap-0.5 border-l-2 pl-2">
          <p className="font-medium">
            {intl.formatDate(isoDate(appointment.appointment_date), { format: "day" })} · {appointment.client_name} · {appointmentStatusLabel(appointment.status)}
          </p>
          <ServiceLines appointment={appointment} />
        </div>
      ))}
    </DataCard>
  );
}
